module.exports = __webpack_public_path__ + "static/media/burger-builder.2fda5a59.webp";